import { Text } from '../Text'
import { Column, Row } from '../Grid'
import { NextImage } from '../NextImage'

const ConsultationDuration = () => {
  return (
    <Row maxWidth='160px' width='100%' minHeight='79px'>
      <Column width='15px' mr='16px' justifyContent='center'>
        <NextImage
          height={16}
          width={16}
          src='/static/images/counterclockwise-rotation.svg'
          alt=''
        />
      </Column>
      <Column>
        <Text
          color='primary'
          textAlign='left'
          fontSize={['1rem', '1rem', '1.5rem']}
          fontWeight='400'
          lineHeight='24px'
        >
          50 min
        </Text>
        <Text textAlign='left' color='lightGray' fontSize={['0.75rem', '0.75rem', '1rem']}>
          duração da consulta
        </Text>
      </Column>
    </Row>
  )
}

export default ConsultationDuration
